import {Route} from '@angular/router';
import {AuthGuard} from './core/guards/auth.guard';
import {GuestGuard} from './core/guards/guest.guard';
import {RoutePath} from "./data/const/routes.const";

export const routes: Route[] = [
  {
    path: '',
    loadChildren: () => import('./modules/dashboard/dashboard.routing'),
    canActivate: [AuthGuard.canActivate]
  },
  {
    path: RoutePath.SESSIONS,
    loadChildren: () => import('./modules/sessions/sessions.routing'),
    canActivate: [GuestGuard.canActivate]
  }
];
